<template>
  <v-app-bar
    :class="['header', { 'sidebar-collapsed': !sideBar }]"
    flat
  >
    <v-app-bar-nav-icon style="color:#000000" @click="openCloseSideBar" />
    <v-app-bar-title>
      <h3 class="secondary-color">
        Cashier sandbox
      </h3>
    </v-app-bar-title>

    <v-spacer></v-spacer>

    <transition name="fade">
      <div class="preset-saved caption mr-4" v-if="presetSaved">
        <span style="font-weight:bold">"{{ presetSaved }}"</span> was succesfully saved!
      </div>
    </transition>

    <v-autocomplete
      :items="getCountries"
      v-model="chosedCountry"
      variant="solo-inverted"
      rounded
      flat
      hide-details
      :label="countryLabel"
      prepend-inner-icon="mdi-magnify"
      class="mr-5"
      style="max-width:200px"
    ></v-autocomplete>

    <v-btn @click="reloadCashier" variant="flat" class="theme-main-bg text-white" rounded>
      <v-icon>mdi-reload</v-icon>
    </v-btn>

    <v-btn @click="savePresetMethod" variant="outlined" rounded class="theme-main-color px-5 mx-5">
      Presets
    </v-btn>

    <v-btn @click="viewDemo" variant="flat" rounded class="theme-main-bg text-white px-5">
      View Demo
    </v-btn>

    <SavePresetModal
      :key="savePresetModal"
      :savePreset="savePreset"
      :dialog="savePresetModal"
      :closeDialog="closeDialog"
      :presetName="preset"
      @update:dialog="savePresetModal = $event"
    />
  </v-app-bar>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import SavePresetModal from '@/components/SavePresetModal'

export default {
  name: 'Header',
  components: {
    SavePresetModal
  },
  data: () => ({
    currentPresetCompare: null,
    savePresetModal: false,
    presetSaved: false,
    chosedCountry: ''
  }),
  mounted () {
    setTimeout(() => {
      this.setPresetCompare()
    }, 1000)
  },
  watch: {
    preset (preset) {
      this.setPresetCompare()
    },
    chosedCountry (country) {
      const { userId } = this.countries.find(val => val.country === country)
      this.setConfigs({ userId })
    }
  },
  computed: {
    ...mapState({
      sideBar: ({ config }) => config.sideBar,
      config: ({ context }) => context.config,
      theme: ({ theme }) => theme.theme,
      customCss: ({ theme }) => theme.customCss,
      preset: ({ config }) => config.preset,
      presets: ({ config }) => config.allPresets,
      countries: ({ context }) => context.countries
    }),
    getCountries () {
      return this.countries.map(country => country.country).sort()
    },
    countryLabel () {
      return this.chosedCountry ? ' ' : 'Select country'
    }
  },
  methods: {
    ...mapActions([
      'setConfigs'
    ]),
    ...mapMutations([
      'sideBarMutation',
      'reloadCashierMutation',
      'setPresets',
      'setPresetName',
      'setCustomCss'
    ]),
    reloadCashier () {
      this.reloadCashierMutation()
    },
    closeDialog () {
      this.savePresetModal = false
    },
    savePreset (name = this.preset) {
      const storagePresets = localStorage.getItem('presets')
      const newPreset = {
        label: name,
        config: { ...this.config },
        theme: { ...this.theme },
        style: this.customCss ? this.customCss[this.preset] : ''
      }
      const getSavedStoragePresets = {
        ...storagePresets && JSON.parse(storagePresets),
        [name]: newPreset
      }
      localStorage.setItem('presets', JSON.stringify(getSavedStoragePresets))
      this.setPresetCompare()
      this.savePresetModal = false
      this.presetSaved = name
      const newPresets = {
        ...this.presets,
        [name]: newPreset
      }
      this.setPresets(newPresets)
      this.setPresetName(name)
      this.setCustomCssMethod()
      setTimeout(() => {
        this.presetSaved = false
      }, 2000)
    },
    setCustomCssMethod () {
      const allPreset = this.presets
      const allCustomCss = {}
      for (const preset in allPreset) {
        allCustomCss[allPreset[preset].label] = allPreset[preset].style
      }
      this.setCustomCss(allCustomCss)
    },
    createCompareString () {
      const { config, theme, customCss, preset } = this
      const CSS = customCss && customCss[preset] ? customCss[preset] : ''
      const str = `${JSON.stringify(config)}${JSON.stringify(theme)}${JSON.stringify(CSS)}`
      return str
    },
    setPresetCompare () {
      this.currentPresetCompare = this.createCompareString()
    },
    openCloseSideBar () {
      this.sideBarMutation(!this.sideBar)
    },
    savePresetMethod () {
      this.savePresetModal = true
    },
    viewDemo () {
      const customCss = this.customCss && this.customCss[this.preset]
      const { config, theme } = this
      const demoConfigs = { customCss, config, theme }
      let demoPage = null
      const demoUrl = window.location.href.split('/')
      demoUrl[demoUrl.length - 1] = 'demo'
      const configsInURL = encodeURIComponent(JSON.stringify(demoConfigs).replace(/ /g, ''))
      const url = `${demoUrl.join('/')}#__PiqCashierConfigs__=${configsInURL}`
      demoPage = window.open(url)
      demoPage.__PiqCashierConfigs__ = demoConfigs
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  margin-left: 20px;
  border-radius: .5rem;
  box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
  transition: all 0.3s ease;
  // box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 15px 0px!important;
}
.v-toolbar {
  z-index: 100!important;
}
.preset-saved {
  padding: 10px;
  border-radius: 15px;
  background: lightgreen;
  box-shadow: 2px 2px 2px lightgrey;
  color: grey;
}
</style>
